"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicSDKModule = exports.TectonicSDKBase = void 0;
const lodash_1 = __importDefault(require("lodash"));
const error_1 = require("./error");
const ContractFactories = __importStar(require("@cronos-labs/tectonic-contract-types"));
class TectonicSDKBase {
    constructor() {
        this.assets = [];
        this.cachedContracts = new Map();
    }
    get signer() {
        if (this.walletNotConnected) {
            throw new error_1.TectonicSDKError('Wallet is not connected', error_1.TectonicSDKErrorType.other);
        }
        if (this.externalSigner) {
            return this.externalSigner;
        }
        else {
            return this.provider.getSigner();
        }
    }
    getContractByName(contractName) {
        if (this.cachedContracts.has(contractName)) {
            return this.cachedContracts.get(contractName);
        }
        const toCreateContractState = lodash_1.default.find(this.world, (c) => c.contractName === contractName);
        if (!toCreateContractState) {
            throw new error_1.TectonicSDKError(`Contract with name: ${contractName} is not found in deployed state.`);
        }
        const toCreateContractFactory = ContractFactories[`${toCreateContractState.contractType}Factory`];
        if (!toCreateContractFactory) {
            throw new error_1.TectonicSDKError(`ContractFactory with name: ${toCreateContractState.contractType} is not defined.`);
        }
        const signerOrProvider = this.walletNotConnected
            ? this.provider
            : this.signer;
        const toCreateContract = toCreateContractFactory.connect(toCreateContractState.address, signerOrProvider);
        this.cachedContracts.set(contractName, toCreateContract);
        return toCreateContract;
    }
    getContractByAddressAndType(address, contractType) {
        const toCreateContractFactory = ContractFactories[`${contractType}Factory`];
        if (!toCreateContractFactory) {
            throw new error_1.TectonicSDKError(`ContractFactory with type: ${contractType} is not defined.`);
        }
        const signerOrProvider = this.walletNotConnected
            ? this.provider
            : this.signer;
        const toCreateContract = toCreateContractFactory.connect(address, signerOrProvider);
        return toCreateContract;
    }
    getContractByAddress(address) {
        // Address to Name
        const contractState = lodash_1.default.find(this.world, (c) => c.address === address);
        if (!contractState) {
            throw new error_1.TectonicSDKError(`Contract with address: ${address} is not found in deployed state.`);
        }
        return this.getContractByName(contractState.contractName);
    }
    getTectonicCore() {
        if (this.cachedContracts.has('TectonicCore')) {
            return this.cachedContracts.get('TectonicCore');
        }
        const tSocket = this.getContractByName('TectonicSocket');
        const signerOrProvider = this.walletNotConnected
            ? this.provider
            : this.signer;
        const tCore = ContractFactories.TectonicCoreFactory.connect(tSocket.address, signerOrProvider);
        this.cachedContracts.set('TectonicCore', tCore);
        return tCore;
    }
    getTectonicStakingPool() {
        if (this.cachedContracts.has('TectonicStakingPool')) {
            return this.cachedContracts.get('TectonicStakingPool');
        }
        const stakingPoolProxy = this.getContractByName('TectonicStakingPoolProxy');
        const signerOrProvider = this.walletNotConnected
            ? this.provider
            : this.signer;
        const stakingPool = ContractFactories.TectonicStakingPoolV2Factory.connect(stakingPoolProxy.address, signerOrProvider);
        this.cachedContracts.set('TectonicStakingPool', stakingPool);
        return stakingPool;
    }
    getTectonicVault() {
        if (this.cachedContracts.has('TectonicVault')) {
            return this.cachedContracts.get('TectonicVault');
        }
        const vaultProxy = this.getContractByName('TectonicVaultProxy');
        const signerOrProvider = this.walletNotConnected
            ? this.provider
            : this.signer;
        const vault = ContractFactories.TONICVaultV3Factory.connect(vaultProxy.address, signerOrProvider);
        this.cachedContracts.set('TectonicVault', vault);
        return vault;
    }
    /**
     *
     * @param tectonicSocketAddress
     * @param fromAmount
     * @param slippageTolerance
     * @param path
     * @returns [tTokenAmount, amountOutMin]
     */
    async getTTokenAmountOut(tectonicSocketAddress, fromAmount, slippageTolerance, path) {
        const deferLiquidityCheckAdapter = this.getDeferLiquidityCheckAdapter();
        return deferLiquidityCheckAdapter.getTTokenAmountOut(tectonicSocketAddress, fromAmount, slippageTolerance, path);
    }
    getXTonic() {
        return this.getContractByName('XTonic');
    }
    getTonic() {
        return this.getContractByName('TONIC');
    }
    getClaimTokenHelper() {
        return this.getContractByName('ClaimTokenHelper');
    }
    getTokenRewarder() {
        return this.getContractByName('TokenRewarder');
    }
    getCronosOracleRegistry() {
        return this.getContractByName('CronosOracleRegistry');
    }
    getDeferLiquidityCheckAdapter() {
        return this.getContractByName('DeferLiquidityCheckAdapter');
    }
    getTectonicBoost() {
        return this.getContractByName('TectonicBoost');
    }
}
exports.TectonicSDKBase = TectonicSDKBase;
class TectonicSDKModule extends TectonicSDKBase {
    constructor(sdk) {
        super();
        this.sdk = sdk;
        this.sdk = sdk;
        // console.log(Object.getOwnPropertyNames(Object.getPrototypeOf(this)));
        for (const key of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
            if (key !== 'constructor') {
                this[key] = this[key].bind(sdk);
            }
        }
    }
}
exports.TectonicSDKModule = TectonicSDKModule;
//# sourceMappingURL=base.js.map